import { MusicLayer } from "@manager/layer/MusicLayer";
import React from "react";

// tslint:disable:max-classes-per-file

// music should be hosted from storage with new API (support for byte range functionality is needed - Accept-Ranges: bytes)

interface Props {
  className?: string;
}

export class MusicLayerComponent extends React.Component<Props> implements MusicLayer {
  private static JUST_BEFORE_END = 0.01;
  private audioNode: HTMLAudioElement;
  private fadeOutHandler: any;
  private startTimeShift: number;
  private endTimeShift: number;

  constructor(props: Props) {
    super(props);
    
  }

  render() {
    return (
      <div className={`${this.props.className || ""} c-musicLayer`}>
          <audio 
              ref={(node: HTMLAudioElement) => this.audioNode = node}
          />
        </div>
    );
  }

  changeSource(src: string): void {
    this.audioNode.src = src;
    this.audioNode.load();
  }

  setMusicTime(startTime: number, endTime: number): void {
    this.startTimeShift = startTime;
    this.endTimeShift = endTime;
  } 

  fadeOut(): void {
    const initialVolume = this.audioNode.volume;
    this.fadeOutHandler = setInterval(
                () => {
                  this.audioNode.volume -= this.audioNode.volume > 0.01 ? .01 : 0;
                  if (this.audioNode.volume <= 0.01) {
                    clearInterval(this.fadeOutHandler);
                    this.audioNode.pause();
                    // reset volume (needed e.g. on seek bar change)
                    this.audioNode.volume = initialVolume;
                  }
                },
                20);            
  }
    
  play(videoCurrentTime: number, videoDuration: number): void {
    clearInterval(this.fadeOutHandler);
    this.audioNode.play();
    this.audioNode.pause();
    if (videoCurrentTime > this.startTimeShift && videoCurrentTime < (videoDuration - this.endTimeShift) && this.audioNode.src !== "") {
      this.audioNode.pause();
      this.audioNode.play();
    }
  }
  pause(): void {
    if (this.audioNode.src !== "") {
      this.audioNode.pause();
    }
  }

  moveTo(time: number): void {
    if (this.audioNode.src !== "") {
      this.audioNode.load();
      this.audioNode.currentTime = time - this.startTimeShift - MusicLayerComponent.JUST_BEFORE_END;
    }
  }

  changeVolume(volume: number): void {
    this.audioNode.volume = volume;
  }

  changeMuted(isMuted: boolean): void {
    this.audioNode.muted = (isMuted);
  }

  initializeLayer(): void {
  }
}

// tslint:enable:max-classes-per-file
